import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .btns {
    display: flex;
    gap: 16px;
  }

  .error {
    color: ${(props) => props.theme.colors.red};
  }
`;

const AudioSchema = styled.div`
  width: 100%;
  max-width: 100%;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.colors.inactive};
  padding: 16px;
  margin-bottom: 16px;
`;

export default {
  Wrapper,
  AudioSchema,
};
